import './bootstrap';
import '../css/app.css';

import {createApp, defineComponent, h, ref} from 'vue';
import {createInertiaApp, router} from '@inertiajs/vue3';
import { resolvePageComponent } from 'laravel-vite-plugin/inertia-helpers';
import { ZiggyVue } from '../../vendor/tightenco/ziggy';
import {
    NConfigProvider,
    NDialogProvider,
    NNotificationProvider,
    NMessageProvider,
    enGB,
    dateEnGB,
    darkTheme,
    NLoadingBarProvider, useLoadingBar
} from 'naive-ui'
import { createPinia } from 'pinia'


const appName = import.meta.env.VITE_APP_NAME || 'Live Alerts';
const pinia = createPinia()
const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches
createInertiaApp({
    title: (title) => `${title} - ${appName}`,
    resolve: (name) => resolvePageComponent(`./Pages/${name}.vue`, import.meta.glob('./Pages/**/*.vue')),
    setup({ el, App, props, plugin }) {
        const LoadingBarManager = defineComponent({
            setup() {
                const loadingBar = useLoadingBar()

                router.on('start', () => {
                    loadingBar.start()
                })

                router.on('finish', () => {
                    loadingBar.finish()
                })

                router.on('error', () => {
                    loadingBar.error()
                })

                // This component doesn't render anything itself
                return () => null
            }
        })

        const app = createApp({
            render: () => h(NConfigProvider,
                {
                    locale: enGB,
                    dateLocale: dateEnGB,
                    theme: (prefersDark) ? darkTheme : null,
                },
                {
                    default: () => h(NNotificationProvider, null, {
                        default: () => h(NMessageProvider, null, {
                            default: () => h(NDialogProvider, null, {
                                default: () => h(NLoadingBarProvider, null, {
                                    default: () => h('div', [
                                        h(LoadingBarManager),
                                        h(App, props)
                                    ])
                                })
                            })
                        })
                    })
                }
            )
        })

        app.use(plugin)
           .use(ZiggyVue)
           .use(pinia)
           .mount(el);

        return app;
    },
    progress: {
        color: '#4B5563',
    },
});
